// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#header button#toggle-profile.logout {\n     width: 160px;\n}\n\n", ""]);
// Exports
module.exports = exports;
